import React, { useEffect, useState, useMemo } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import PropTypes from "prop-types";

import * as yearActions from "src/redux/actions/year.action";

import * as approvebudgetActions from "src/redux/actions/approvebudget.action";
import * as updateapprovebudgetActions from "src/redux/actions/updateapprovebudget.action";
import * as rejectapprovebudgetActions from "src/redux/actions/rejectapprovebudget.action";
import * as approvebudgethistoryActions from "src/redux/actions/approvebudgethistory.action";
import * as updateinitialapproveActions from "src/redux/actions/updateinitialapprove.action";

import {
  AppBar,
  Tabs,
  Tab,
  TextField,
  Grid,
  Typography,
  makeStyles,
  Button,
  Icon,
  Paper,
  Box,
  Container,
  Card,
  CardHeader,
  Divider,
  CardContent,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import CustomDialog from "src/components/fragments/CustomDialog";
import PopupDialog from "src/components/fragments/PopupDialog";
import Page from "src/components/Page";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "26ch",
    },
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  iconbtnreject: {
    color: "secondary",
  },
}));

export default function ApproveBudget() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [brandId, setBrandId] = useState(0);
  const [deptId, setDeptId] = useState(0);
  const [yearId, setYearId] = useState(0);
  const [yearLock, setYearLock] = useState(null);
  const [budgetsid, setBudgetsid] = useState(null);
  const [openDlgApproveByrec, setOpenDlgApproveByrec] = useState(false);
  const [openDlgRejectApprove, setOpenDlgRejectApprove] = useState(false);
  const [openPopupDlgSucc, setOpenPopupDlgSucc] = useState(false);
  const [openPopupDlgSuccRej, setOpenPopupDlgSuccRej] = useState(false);

  const yearReducer = useSelector(({ yearReducer }) => yearReducer);
  const budgetsReducer = useSelector(
    ({ budgetsReducer }) => budgetsReducer,
    shallowEqual
  );

  const loginReducer = useSelector((state) => state.loginReducer);
  const brandReducer = useSelector((state) => state.brandReducer);
  const approvebudgetReducer = useSelector(
    (state) => state.approvebudgetReducer
  );
  // const brandReducer = useSelector(({ brandReducer }) => brandReducer);
  const departmentReducer = useSelector(
    ({ departmentReducer }) => departmentReducer
  );
  const approvebudgethistoryReducer = useSelector(
    (state) => state.approvebudgethistoryReducer
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeYear = (e) => {
    const { BUDGETH_ID, YEAR_CODE, BUDGETH_LOCK } = JSON.parse(e.target.value);
    // console.log(BUDGETH_ID);
    clearDataDropDown();
    setYearId(BUDGETH_ID);
    // setyearCode(YEAR_CODE);
    // console.log(BUDGETH_LOCK);
    setYearLock(BUDGETH_LOCK);
    // setCheckRecBudget(true);
    // setCheckRecReport(true);
    // setcheckRecSubmit(true);
  };
  const clearDataDropDown = (e) => {
    // dispatch(getprojectActions.clearProject());
    dispatch(approvebudgetActions.clearApprove());
  };
  const handlePopupDlgSucc = (value) => {
    if (value) {
      setOpenPopupDlgSucc(false);
    }
  };

  const handlePopupDlgSuccRej = (value) => {
    if (value) {
      setOpenPopupDlgSuccRej(false);
    }
  };
  const handleConfirmDlgApproveRec = (value) => {
    if (value) {
      dispatch(
        updateapprovebudgetActions.updateApproveById(
          budgetsid,
          loginReducer.result.perid
        )
      ).then((result) => {
        setTimeout(() => {
          if (result) {
            // setCheckRecBudget(true);
            // setCheckRecReport(false);
            // setcheckRecSubmit(false);
          } else {
            // setCheckRecBudget(false);
            // setCheckRecReport(true);
            // setcheckRecSubmit(true);
          }
        }, 1000);
        let data = {
          S_ID: budgetsid,
        };
        dispatch(updateinitialapproveActions.updateInitialApprove(data));
        dispatch(
          approvebudgetActions.getApproveById(
            yearId,
            loginReducer.result.perid,
            loginReducer.result.secureid,
            loginReducer.result.countryid,
            loginReducer.result.companyid
          )
        );
        setTimeout(() => {
          dispatch(
            approvebudgethistoryActions.getApproveByIdHistory(
              yearId,
              loginReducer.result.perid,
              loginReducer.result.secureid,
              loginReducer.result.countryid,
              loginReducer.result.companyid
            )
          );
        }, 1000);
      });
      setOpenPopupDlgSucc(true);
      setOpenDlgApproveByrec(false);
    } else {
      setOpenDlgApproveByrec(false);
    }
  };

  const handleConfirmDlgRejectApproveRec = (value) => {
    if (value) {
      dispatch(
        rejectapprovebudgetActions.rejectApproveById(
          budgetsid,
          loginReducer.result.perid
        )
      ).then((result) => {
        setTimeout(() => {
          if (result) {
            // setCheckRecBudget(true);
            // setCheckRecReport(false);
            // setcheckRecSubmit(false);
          } else {
            // setCheckRecBudget(false);
            // setCheckRecReport(true);
            // setcheckRecSubmit(true);
          }
        }, 1000);
        dispatch(
          approvebudgetActions.getApproveById(
            yearId,
            loginReducer.result.perid,
            loginReducer.result.secureid,
            loginReducer.result.countryid,
            loginReducer.result.companyid
          )
        );
        setTimeout(() => {
          dispatch(
            approvebudgethistoryActions.getApproveByIdHistory(
              yearId,
              loginReducer.result.perid,
              loginReducer.result.secureid,
              loginReducer.result.countryid,
              loginReducer.result.companyid
            )
          );
        }, 1000);
      });
      setOpenPopupDlgSuccRej(true);
      setOpenDlgRejectApprove(false);
    } else {
      setOpenDlgRejectApprove(false);
    }
  };

  const dispatch = useDispatch();

  useEffect(
    () => {
      dispatch(
        yearActions.getYear(
          loginReducer.result.countryid +
            loginReducer.result.companyid +
            brandId +
            yearId
        )
      );

      return () => {
        dispatch(approvebudgetActions.getApproveById(yearId, 0, 0, 0, 0))
          .then((result) => {
            setTimeout(() => {
              if (result) {
                // setCheckRecBudget(true);
                // setCheckRecReport(false);
                // setcheckRecSubmit(false);
              } else {
                // setCheckRecBudget(false);
                // setCheckRecReport(true);
                // setcheckRecSubmit(true);
              }
            }, 1000);
            dispatch(
              approvebudgethistoryActions.getApproveByIdHistory(
                yearId,
                0,
                0,
                0,
                0
              )
            );
          })
          .catch((result) => {});
        dispatch(
          yearActions.getYear(
            loginReducer.result.countryid +
              loginReducer.result.companyid +
              0 +
              0
          )
        );
        // dispatch(budgetsActions.clearBudgets());
      };
    },
    []
    // [countryid, companyid, brandId, deptId, yearId]
  );
  return (
    // <div className={classes.root}>
      /* <Alert icon={false} variant="outlined" severity="success">
        <Box display="flex" justifyContent="space-between" flexWrap="wrap">
          <Box display="flex" flexDirection="row">
            <Box mr={5}>
              {" "}
              <Typography variant="h4">Approve Budget</Typography>
            </Box>
          </Box>
          <Box display="flex" flexDirection="row">
            <Box mr={2}>
              {" "}
              {yearLock === 1 ? (
                <Alert icon={false} severity="warning">
                  <Typography variant="button" display="block">
                    Year Locked
                  </Typography>
                </Alert>
              ) : (
                ""
              )}
            </Box>
          </Box>
        </Box>
      </Alert> */
    <Page className={classes.root} title="Approve Budget">
      <Container maxWidth={false}>
        <Card>
          <CardHeader
            subheader="For approve budget"
            title="Approve Budget"
          />
          {yearLock === 1 ? (
                <Alert icon={false} severity="warning">
                  <Typography variant="button" display="block">
                    Year Locked
                  </Typography>
                </Alert>
              ) : (
                ""
              )}
          <Divider />
          <CardContent>
      <br />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          dispatch(
            approvebudgetActions.getApproveById(
              yearId,
              loginReducer.result.perid,
              loginReducer.result.secureid,
              loginReducer.result.countryid,
              loginReducer.result.companyid
            )
          )
            .then((result) => {
              setTimeout(() => {
                if (result) {
                  // setCheckRecBudget(true);
                  // setCheckRecReport(false);
                  // setcheckRecSubmit(false);
                } else {
                  // setCheckRecBudget(false);
                  // setCheckRecReport(true);
                  // setcheckRecSubmit(true);
                }
              }, 1000);
              dispatch(
                approvebudgethistoryActions.getApproveByIdHistory(
                  yearId,
                  loginReducer.result.perid,
                  loginReducer.result.secureid,
                  loginReducer.result.countryid,
                  loginReducer.result.companyid
                )
              );
            })
            .catch((result) => {});
        }}
      >
        <Grid container xs={12}>
          <Box
            display="flex"
            flexWrap="wrap"
            flex={1}
            style={{ lineHeight: 5 }}
          >
            <TextField
              variant="outlined"
              margin="normal"
              required
              select
              onChange={handleChangeYear}
              label="Year"
              style={{ width: "30%" }}
              SelectProps={{
                native: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
              defaultValue=""
            >
              <option key={0} value="" selected>
                -
              </option>
              {yearReducer.result &&
                yearReducer.result.map((item) => (
                  // <MenuItem value={item}>{item.YEAR_CODE}</MenuItem>
                  <option key={item.YEAR_CODE} value={JSON.stringify(item)}>
                    {/* {item.YEAR_CODE} */}
                    {item.YEAR_SEQ_T}
                  </option>
                ))}
            </TextField>
            <Box style={{ marginLeft: 10 }}>
              <Button
                // variant="outlined"
                variant="contained"
                color="default"
                type="submit"
              >
                <Icon>search</Icon>Search
              </Button>
            </Box>
          </Box>
        </Grid>
      </form>
      <br />
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          variant="fullWidth"
          centered
        >
          <Tab
            style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
            label="Pending"
            {...a11yProps(0)}
          />
          <Tab
            style={{ backgroundColor: "#5c9aff", color: "#FFFF" }}
            label="Approved"
            {...a11yProps(1)}
          />
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        {/* Data */}
        <Grid container spacing={2}>
          <Paper className={classes.root}>
            <MaterialTable
              title="Expenses"
              isLoading={approvebudgetReducer.isFetching}
              on
              columns={[
                // {
                //   title: "SID",
                //   field: "BUDGETS_ID",
                // },
                {
                  title: "Brand",
                  field: "Brand",
                },
                {
                  title: "Department",
                  field: "Department",
                },
                {
                  title: "Expense",
                  field: "SUMEXPENSES",
                  type: "numeric",
                  render: (rowData) => {
                    if (rowData.SUMEXPENSES) {
                      return rowData.SUMEXPENSES.toFixed(2).replace(
                        /(\d)(?=(\d{3})+(?!\d))/g,
                        "$1,"
                      );
                    } else {
                      return "0.00";
                    }
                  },
                },
                {
                  title: "Investment",
                  field: "SUMINVESTMENT",
                  type: "numeric",
                  render: (rowData) => {
                    if (rowData.SUMINVESTMENT) {
                      return rowData.SUMINVESTMENT.toFixed(2).replace(
                        /(\d)(?=(\d{3})+(?!\d))/g,
                        "$1,"
                      );
                    } else {
                      return "0.00";
                    }
                  },
                },
                {
                  title: "Total",
                  field: "SUMTOT_BUDGET",
                  type: "numeric",
                  render: (rowData) => {
                    if (rowData.SUMTOT_BUDGET) {
                      return rowData.SUMTOT_BUDGET.toFixed(2).replace(
                        /(\d)(?=(\d{3})+(?!\d))/g,
                        "$1,"
                      );
                    } else {
                      return "0.00";
                    }
                  },
                },
              ]}
              data={
                approvebudgetReducer.result ? approvebudgetReducer.result : []
              }
              actions={[
                (rowData) => ({
                  disabled: yearLock === null || yearLock === 1,
                  icon: "check",
                  tooltip: "Approve Budget",
                  // color: "secondary",
                  onClick: (e, rowData) => (
                    setBudgetsid(rowData.BUDGETS_ID),
                    // e.preventDefault(),
                    setOpenDlgApproveByrec(true)
                  ),
                }),
                (rowData) => ({
                  disabled: yearLock === null || yearLock === 1,
                  icon: "close",
                  tooltip: "Reject Budget",
                  onClick: (e, rowData) => (
                    setBudgetsid(rowData.BUDGETS_ID),
                    // e.preventDefault(),
                    setOpenDlgRejectApprove(true)
                  ),
                }),
              ]}
              options={{
                exportButton: true,
                toolbarButtonAlignment: "left",
                exportAllData: true,
                headerStyle: {
                  backgroundColor: "#5c9aff",
                },
                rowStyle: {
                  backgroundColor: "#edf4ff",
                },
                showTitle: false,
                searchFieldAlignment: "left",
                pageSize: 5,
                pageSizeOptions: [5, 10, 50, 100],
                paging: true,
              }}
            />
          </Paper>
        </Grid>
      </TabPanel>

      <TabPanel value={value} index={1}>
        {/* Data */}
        <Grid container spacing={2}>
          <Paper className={classes.root}>
            <MaterialTable
              title="Expenses"
              isLoading={approvebudgethistoryReducer.isFetching}
              on
              columns={[
                {
                  title: "Brand",
                  field: "Brand",
                },
                {
                  title: "Department",
                  field: "Department",
                },
                {
                  title: "Expense",
                  field: "SUMEXPENSES",
                  type: "numeric",
                  render: (rowData) => {
                    if (rowData.SUMEXPENSES) {
                      return rowData.SUMEXPENSES.toFixed(2).replace(
                        /(\d)(?=(\d{3})+(?!\d))/g,
                        "$1,"
                      );
                    } else {
                      return "0.00";
                    }
                  },
                },
                {
                  title: "Investment",
                  field: "SUMINVESTMENT",
                  type: "numeric",
                  render: (rowData) => {
                    if (rowData.SUMINVESTMENT) {
                      return rowData.SUMINVESTMENT.toFixed(2).replace(
                        /(\d)(?=(\d{3})+(?!\d))/g,
                        "$1,"
                      );
                    } else {
                      return "0.00";
                    }
                  },
                },
                {
                  title: "Total",
                  field: "SUMTOT_BUDGET",
                  type: "numeric",
                  render: (rowData) => {
                    if (rowData.SUMTOT_BUDGET) {
                      return rowData.SUMTOT_BUDGET.toFixed(2).replace(
                        /(\d)(?=(\d{3})+(?!\d))/g,
                        "$1,"
                      );
                    } else {
                      return "0.00";
                    }
                  },
                },
              ]}
              data={
                approvebudgethistoryReducer.result
                  ? approvebudgethistoryReducer.result
                  : []
              }
              options={{
                exportButton: true,
                toolbarButtonAlignment: "left",
                exportAllData: true,
                headerStyle: {
                  backgroundColor: "#5c9aff",
                },
                rowStyle: {
                  backgroundColor: "#edf4ff",
                },
                showTitle: false,
                searchFieldAlignment: "left",
                pageSize: 5,
                pageSizeOptions: [5, 10, 50, 100],
                paging: true,
              }}
            />
          </Paper>
        </Grid>
      </TabPanel>

      <CustomDialog
        title="Confirmation dialog"
        message="Confirm to Approve budget?"
        open={openDlgApproveByrec}
        onClose={handleConfirmDlgApproveRec}
      />
      <CustomDialog
        title="Confirmation dialog"
        message="Confirm to Reject budget?"
        open={openDlgRejectApprove}
        onClose={handleConfirmDlgRejectApproveRec}
      />

      <PopupDialog
        title="Information Message Approve"
        message={<Alert severity="success">Approve budget successful.</Alert>}
        open={openPopupDlgSucc}
        onClose={handlePopupDlgSucc}
      />

      <PopupDialog
        title="Information Message Reject"
        message={<Alert severity="success">Reject budget successful.</Alert>}
        open={openPopupDlgSuccRej}
        onClose={handlePopupDlgSuccRej}
      />
      </CardContent>
        </Card>
      </Container>
    </Page>

  );
}
